import {ShortUser} from './ShortUser';
import {Image} from './Image';
import {District} from './District';
import {LinkedEntity} from './LinkedEntity';
import {Competition} from './Competition';
import {Match} from './Match';
import {CompetitionSeason} from './CompetitionSeason';
import {TeamSeason} from './TeamSeason';
import {Club} from './Club';

export class Gallery {
  readonly id: number;
  readonly slug: string;
  readonly title: string;
  readonly created: string | null;
  readonly user?: ShortUser;
  readonly userAlias: string;
  readonly match?: Match;
  readonly thumbnail: {image: Image} | null; // A gallery image is currently nested
  readonly competition?: Competition;
  readonly links?: {
    competitions?: LinkedEntity<CompetitionSeason>[];
    teams?: LinkedEntity<TeamSeason>[];
    districts?: LinkedEntity<District>[];
    clubs?: LinkedEntity<Club>[];
  };
  readonly isActive: boolean;
}

/**
 * A reduced version of a {@see Gallery} to be used as nested data of other resources.
 */
export class RelatedGallery {
  readonly id: number;
  readonly slug: string;
  readonly thumbnail: Image | null;
}
